import { eventBus } from '@mtfe/sweet-utils';
import IndexWmCrazy from '../pages/indexWmCrazy/script.js';
import IndexWmWelfare from '../pages/indexWmWelfare/script.js';
import Search from '../pages/search/script.js';
import Result from '../pages/result/script.js';
import ResultReady from '../pages/result/ready.js';
import store from '../store/index.js';
import http from '../service/index.js';

const { storeCommon } = store;

// 初始化页面结构信息
const initPageStructInfo = async () => {
    // 前置请求性能埋点 start
    const [tabsInfoRes, structInfoRes] = await Promise.all([
        http.getCategoryInfo(), // 处理recallBizID
        http.getStructConfig(), // 首页结构数据与实验数据请求
    ]);

    const tabsInfo = tabsInfoRes.data;
    const structInfo = structInfoRes.data;

    storeCommon.structInfo = structInfo;
    storeCommon.tabsInfo = tabsInfo;
    return {
        structInfo,
        tabsInfo,
    };
};

const crazyConfig = {
    index: {
        component: IndexWmCrazy,
        pageReady: () => {
            eventBus.$emit('indexWmCrazyReady');
            eventBus.clearEvent('indexWmCrazyReady');
        },
    },
};
const welFareConfig = {
    index: {
        component: IndexWmWelfare,
        pageReady: () => {
            eventBus.$emit('indexWmWelfareReady');
            eventBus.clearEvent('indexWmWelfareReady');
        },
    },
};

const routerConfig = {
    search: {
        component: Search,
        isRetain: false,
        refresh: true,
    },
    result: {
        component: Result,
        pageReady: ResultReady,
        isRetain: false,
        refresh: true,
    },
};

const getRouterConfig = async () => {
    try {
        const { structInfo } = await initPageStructInfo();
        // 是否展示疯狂大额券实验
        const isShowCrazy = structInfo.expInfo && structInfo.expInfo.bigCoupon === 'true';

        return isShowCrazy ? Object.assign(routerConfig, crazyConfig) : Object.assign(routerConfig, welFareConfig);
    } catch (error) {
        console.error(error);
        throw new Error('页面加载失败');
    }
};

export default getRouterConfig;
